// A small circled-"i" affordance that surfaces a definition on hover (native title).
// Use it next to a metric label whose meaning isn't self-evident.
export function InfoDot({ title }: { title: string }) {
  return (
    <span
      title={title}
      role="img"
      aria-label="info"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 13,
        height: 13,
        borderRadius: "50%",
        border: "1px solid var(--ink-4)",
        color: "var(--ink-4)",
        fontSize: 9,
        fontStyle: "italic",
        fontWeight: 700,
        lineHeight: 1,
        cursor: "help",
        flex: "none",
      }}
    >
      i
    </span>
  );
}

// The shared definition of the proxy-pool pressure gauge, so both the dashboard card
// and the run-page panel explain "demand / capacity" identically.
export const PRESSURE_HELP =
  "Pressure = demand ÷ capacity. " +
  "Demand = leases currently held + acquire denials in the last 5s. " +
  "Capacity = usable right now = leased + free. " +
  "When free hits 0, capacity = leased, so any unmet demand pushes pressure ≥ 1 (starvation, red). " +
  "Uncapped: a value of N means demand is N× what's leasable this instant.";
